export default __webpack_public_path__ + "static/media/dreamroom.5f1628a4.jpg";